import {
  BundleNames,
  LpxTheme,
  LpxThemeOptions,
  StyleNames,
  ThemeTranslateKeys,
} from '@volosoft/ngx-lepton-x';

// The appearances offered in General Settings. LeptonX ships Light, Semi-Dark (dim) and Dark plus a
// synthetic System entry; US #153472 keeps only Light and Dark. ThemeService resolves the stored
// appearance against this list, so an account left on `dim` or `system` no longer matches and falls back
// to the entry flagged `defaultTheme` — which is why no data migration is needed.
export const ACX_APPEARANCES: LpxTheme[] = [
  new LpxTheme({
    bundles: [{ bundleName: BundleNames.BootstrapLight }, { bundleName: BundleNames.Light }],
    styleName: StyleNames.Light,
    icon: 'bi bi-sun-fill',
    label: ThemeTranslateKeys.LightMode,
    defaultTheme: true,
  }),
  new LpxTheme({
    bundles: [{ bundleName: BundleNames.BootstrapDark }, { bundleName: BundleNames.Dark }],
    styleName: StyleNames.Dark,
    icon: 'bi bi-moon-fill',
    label: ThemeTranslateKeys.DarkMode,
  }),
];

// `disableSystemOption` is what stops ThemeService from appending the System entry to the list above.
// The storage key stays LeptonX's own so an account already on Dark keeps it.
export const ACX_THEME_OPTIONS: LpxThemeOptions = {
  localStorageKey: 'LPX_THEME',
  disableSystemOption: true,
};
